import { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left.svg";
import CustomInput from "../../../components/CustomInput";
import FolderOpenIcon from "../../../../media/images/icons/folder-open";
import FolderAddIcon from "../../../../media/images/icons/folder-add";
import CustomButton from "../../../components/CustomButton";
import SmsTrackingIcon from "../../../../media/images/icons/sms-tracking";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import CustomAutoComplete from "../../../components/CustomAutoComplete";
import { useFormik } from "formik";
import CloseCircleSVG from "../../../../media/images/icons/close-icon";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../redux/features/dialogSlice";
import { useNavigate } from "react-router-dom";

export default function SendTicketPage() {
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  const theme = useTheme();

  const { fullName } = useAppSelector((state) => state.user);

  const dispatch = useAppDispatch();

  const [takeTicketDepartmentInputValue, setTakeTicketDepartmentInputValue] =
    useState("");
  const [takeTicketDepartmentOptions, setTakeTicketDepartmentOptions] =
    useState([]);

  const { trigger: takeTicketDepartment } = useSWRMutation(
    [`/Ticket/TakeTicketDepartment`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setTakeTicketDepartmentOptions(data);
      },
    }
  );

  const {
    trigger: createTicketTrigger,
    isMutating: iscreateTicketTriggerMutating,
  } = useSWRMutation(
    [`/Ticket/CreateTicket`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        dispatch(setOpenDialog(true));
        dispatch(setDialogStatus("success"));
        dispatch(setDialogTitle("تیکت با موفقیت ثبت شد!"));
        // dispatch(setDialogDescription("...درحال انتقال به صفحه اصلی"));

        sendTicketFormik.resetForm();
        navigate("/driver/ticket");
        setTakeTicketDepartmentOptions(data);
      },
    }
  );

  const {
    trigger: uploadTicketFileTrigger,
    // isMutating: isUploadTicketFileTriggerMutating,
  } = useSWRMutation(
    [`/Ticket/Upload`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        sendTicketFormik.setFieldValue("attach1", data);
      },
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      takeTicketDepartment({
        name: takeTicketDepartmentInputValue || null,
      });
    }, 1000);
    return () => clearTimeout(timer);
  }, [takeTicketDepartmentInputValue]);

  const sendTicketFormik = useFormik({
    initialValues: {
      attach1: null,
      depObject: null,
      title: "",
      text: "",
      depId: "",
    },
    onSubmit: (values) => {
      const { depObject, ...newValues } = values;
      createTicketTrigger({
        ...newValues,
        depId: depObject!["value"],
      });
    },
  });

  const handleChangeAutoComplete = (selected: any, type?: string) => {
    switch (type) {
      case "dep-object":
        sendTicketFormik.setFieldValue("depObject", selected);

        break;

      default:
        break;
    }
  };

  return (
    <>
      <MobileHeader title={HeadTitle()} />
      <Box
        sx={{
          paddingX: "8px",
        }}
      >
        <Box
          sx={{
            marginTop: "16px",
            width: "100%",
            backgroundColor: "bgColor.white",
            padding: "12px",
            borderRadius: "16px",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "600",
              color: "primary.main",
              fontSize: "16px",
            }}
          >
            ارسال تیکت پشتیبانی جدید{" "}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "16px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              درخواست کننده:
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                color: theme.palette.secondary.main,
              }}
            >
              {fullName}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              marginTop: "8px",
            }}
          >
            <CustomAutoComplete
              inputValue={takeTicketDepartmentInputValue}
              setInputValue={setTakeTicketDepartmentInputValue}
              type={"dep-object"}
              placeHolder="بخش مربوطه را انتخاب کنید"
              setValue={handleChangeAutoComplete}
              value={sendTicketFormik.values.depObject}
              // error={
              //   reciverFormik.touched.nationIdSelected &&
              //   Boolean(reciverFormik.errors.nationIdSelected)
              // }
              // errorMessage={
              //   reciverFormik.touched.nationIdSelected &&
              //   String(reciverFormik.errors.nationIdSelected)
              // }
              options={takeTicketDepartmentOptions || []}
              mb="0px"
            />
            <CustomInput
              name="title"
              placHolder="عنوان درخواست را وارد کنید"
              handelChange={sendTicketFormik.handleChange}
              value={sendTicketFormik.values.title}
            />
            <CustomInput
              name="text"
              handelChange={sendTicketFormik.handleChange}
              value={sendTicketFormik.values.text}
              textArea
              placHolder="متن درخواست را وارد کنید..."
            />

            {sendTicketFormik.values.attach1 && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "8px",
                  backgroundColor: theme.palette.bgColor.grey100,
                  borderRadius: "8px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FolderOpenIcon
                    size={28}
                    color={theme.palette.primary.main}
                  />
                  <Typography sx={{ color: "primary.main", fontWeight: "600" }}>
                    {sendTicketFormik.values.attach1["name"]}
                  </Typography>
                </Box>
                <CustomButton
                  // loading={loading}
                  onClick={() =>
                    sendTicketFormik.setFieldValue("attach1", null)
                  }
                  flexDirection="row"
                  title="حذف فایل"
                  justifyContent="center"
                  bgColor="error.light"
                  gap="4px"
                  // width="100%"
                  borderColor="error.main"
                  fSize="12px"
                  fWeight="700"
                  textColor="error.main"
                  px="8px"
                  py="8px"
                  borderRadius="8px"
                  icon1={
                    <CloseCircleSVG
                      color={theme.palette.error.main}
                      size={18}
                    />
                  }
                  // mt="16px"
                />
              </Box>
            )}

            <Box
              sx={{
                display: "flex",
                alignItems: "start",
                gap: "8px",
              }}
            >
              <Box
                onClick={() => inputRef.current?.click()}
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: "4px",
                  alignItems: "center",
                  backgroundColor: theme.palette.bgColor.grey100,
                  border: "1px dashed",
                  justifyContent: "center",
                  borderColor: "primary.main",
                  padding: "8px 4px",
                  borderRadius: "8px",
                }}
              >
                <input
                  hidden
                  type="file"
                  ref={inputRef}
                  onChange={(e) => {
                    if (e.target.files?.length) {
                      const myFile = e.target.files[0];

                      const myFormData = new FormData();

                      // handleUploadFile(e.target.files[0], index);

                      myFormData.append("file", myFile);
                      myFormData.append("name", "attach1");

                      uploadTicketFileTrigger(myFormData);

                      // handleUploadFile(e.target.files[0], title);

                      // setFilePath(URL.createObjectURL(myFile));
                    }
                  }}
                />
                <FolderAddIcon color={theme.palette.primary.main} />
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                  color="primary.main"
                >
                  پیوست فایل به تیکت
                </Typography>
              </Box>
              {/* <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  alignItems: "center",
                  borderWidth: "1px",
                  borderColor: theme.palette.primary.main,
                  borderStyle: "solid",
                  padding: "8px 4px",
                  borderRadius: "8px",
                  backgroundColor: "info.light",
                }}
              >
                <CameraFillIcon color={theme.palette.primary.main} />
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                  color="primary.main"
                >
                  پیوست عکس از طریق دوربین موبایل
                </Typography>
              </Box> */}
            </Box>

            <CustomButton
              loading={iscreateTicketTriggerMutating}
              onClick={sendTicketFormik.handleSubmit}
              flexDirection="row"
              title="ارسال درخواست به ایستگاه"
              justifyContent="center"
              bgColor="secondary.main"
              width="100%"
              fSize="16px"
              px="10px"
              py="10px"
              borderRadius="10px"
              icon1={<SmsTrackingIcon color="#ffffff" size={32} />}
              mt="16px"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}

function HeadTitle() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        onClick={() => navigate("../ticket")}
        sx={{
          cursor: "pointer",
          color: "secondary.main",
          fontWeight: 700,
          fontSize: "16px",
        }}
      >
        پشتیبانی{" "}
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        sx={{
          color: "secondary.main",
          fontSize: "14px",
          fontWeight: 700,
        }}
      >
        ایجاد درخواست جدید
      </Typography>
    </Box>
  );
}
